/* eslint-disable react/no-array-index-key */
import { BEMBlock } from 'helpers/classnames';
import { Typography } from 'palette/Typography';
import { DEFAULT_TYPOGRAPHY_STRUCTURE } from '../constants';
import { getPriceTypographyProps } from '../helpers';
import {
    ProductPrice,
    ProductPricesCollection,
    ProductPriceTypographyStructure,
} from '../types';
import '../style/ProductPrices.scss';

interface ProductPricesProps {
    productPrices: ProductPricesCollection[];
    typographyStructure?: Partial<ProductPriceTypographyStructure>;
}

export function ProductPrices({
    productPrices,
    typographyStructure = DEFAULT_TYPOGRAPHY_STRUCTURE,
}: ProductPricesProps) {
    const isSinglePrice: boolean = productPrices.length === 1;

    const [block, BEMElement] = BEMBlock('product-prices', { 'is-single-price': isSinglePrice });

    return (
        <>
            {productPrices.map((priceCollection: ProductPricesCollection, collectionIndex) => (
                <div
                    key={collectionIndex}
                    className={block}
                >
                    {priceCollection.map((priceElement: ProductPrice, elementIndex) => {
                        const productPriceTypographyProps = getPriceTypographyProps(
                            priceElement, typographyStructure,
                        );

                        return (
                            <div
                                key={elementIndex}
                                className={BEMElement('price', {
                                    'with-background': priceElement.background_color,
                                })}
                                style={{
                                    ...(priceElement.background_color && { backgroundColor: priceElement.background_color }),
                                    color: priceElement.foreground_color,
                                }}
                            >
                                <Typography {...productPriceTypographyProps}>
                                    {priceElement.value}
                                </Typography>
                            </div>
                        );
                    })}
                </div>
            ))}
        </>
    );
}
